// ABOUTME: The orders page TopRow KPI cards, extracted as standalone presentational components so each one
// ABOUTME: can be reused both on the orders page and dropped individually into a BI dashboard cell.
import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Text from "../../../../../components/theme/text/Text";
import PopoverModal from "../../../../../components/theme/Modal/PopoverModal";
import { StreamDisplayData } from "../../../../../components/global/DataGrid/Filters/Order/StreamDisplayData";
import { tokens } from "../../../../../theme";
import { formatNumber } from "../../../../../utils/helpers";

// All four cards read the same `useGetDashboardOrderTotalsQuery` payload (passed in as `totalData`); the
// orders page fetches it once for the row, and a BI dashboard cell fetches it once via the order_totals source.

// Today + later: to-process breakdown (picked / in-stream / can-be-picked) and to-process-later totals.
export const OrdersTodayToProcessCard = ({ totalData, isLoading, isFetching, sx }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [anchorEl, setAnchorEl] = useState(null);
    const handlePopoverOpen = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    const handlePopoverClose = () => setAnchorEl(null);

    return (
        <Box
            key={"today_to_process"}
            sx={{
                flex: 2,

                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                p: 1,
                pb: 1.5,
                px: 1.5,
                borderRadius: 5,
                ...sx,
            }}
        >
            <Box
                sx={{
                    p: 1,
                    px: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: 'column'
                    }}
                >
                    <Text>{t("today")}</Text>
                    <Text light>{t("to_process")}</Text>
                </Box>

                <Typography
                    sx={{
                        lineHeight: "21px",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: 21,
                        fontWeight: "1000",
                        color: colors.txt["primary"]
                    }}
                >

                    {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_all_total)}
                </Typography>

            </Box>
            {/* Amount split out */}
            <Box
                sx={{
                    mt: 1,
                    display: "flex",
                    gap: 1.5,
                    ...sx?.amountContainer
                }}
            >
                <Box
                    sx={{
                        flex: 2,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Text variant={theme.palette.mode === "dark" ? "blue" : "primary"} semibold>{t("to_process_now")}</Text>

                        <Typography
                            sx={{
                                lineHeight: "17px",
                                fontFamily: "Roboto, sans-serif",
                                fontSize: 17,
                                fontWeight: "700",
                                color: colors.txt["primary"]
                            }}
                        >

                            {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_now_total)}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            mt: 1.5,
                            background: theme.palette.mode === "dark" ? colors.blue[100] : colors.grey[0],
                            borderRadius: 3,

                        }}
                    >
                        <Box
                            sx={{
                                p: 1,
                                px: 1.5,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: 'center',
                                }}
                            >
                                <Box
                                    sx={{
                                        height: 24,
                                        width: 24,
                                        borderRadius: 4,
                                        background: colors.green[100],
                                        border: `2px solid ${colors.green[400]}`,

                                        mr: 1.5,
                                    }}
                                >

                                </Box>
                                <Text sx={{ mr: 3 }}>{t("picked")}</Text>

                                <Typography
                                    sx={{
                                        lineHeight: "14px",
                                        fontFamily: "Roboto, sans-serif",
                                        fontSize: 14,
                                        fontWeight: "700",
                                        color: colors.txt["primary"],
                                        ml: "auto",
                                    }}
                                >

                                    {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_now_picked)}
                                </Typography>

                            </Box>
                            <Box
                                sx={{
                                    mt: 1.5,
                                    display: "flex",
                                    alignItems: 'center',
                                }}
                            >
                                <Box
                                    sx={{
                                        height: 24,
                                        width: 24,
                                        borderRadius: 4,
                                        background: colors.orange[100],
                                        border: `2px solid ${colors.orange[400]}`,
                                        mr: 1.5,
                                    }}
                                >

                                </Box>
                                <Text sx={{ mr: 3 }}>{t("in_stream")}</Text>

                                <Typography
                                    sx={{
                                        lineHeight: "14px",
                                        fontFamily: "Roboto, sans-serif",
                                        fontSize: 14,
                                        fontWeight: "700",
                                        color: colors.txt["primary"],
                                        ml: "auto",
                                    }}
                                >

                                    {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_now_picking)}
                                </Typography>

                            </Box>
                            <Box
                                onClick={handlePopoverOpen}
                                sx={{
                                    mt: 1.5,
                                    display: "flex",
                                    alignItems: 'center',
                                    cursor: "pointer",
                                    transition: "250ms",
                                    "&:hover": {
                                        background: colors.grey[100],
                                        px: 0.5,
                                        transition: "250ms",
                                        borderRadius: 4,
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        height: 24,
                                        width: 24,
                                        borderRadius: 4,
                                        background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                        border: `2px solid ${theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                                        mr: 1.5,
                                    }}
                                >

                                </Box>
                                <Text sx={{ mr: 3 }}>{t("order_can_be_picked")}</Text>

                                <Typography
                                    sx={{
                                        lineHeight: "14px",
                                        fontFamily: "Roboto, sans-serif",
                                        fontSize: 14,
                                        fontWeight: "700",
                                        color: colors.txt["primary"],
                                        ml: "auto",
                                    }}
                                >

                                    {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_now_open)}
                                </Typography>

                            </Box>
                            <PopoverModal
                                id="simple-popover"
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handlePopoverClose}
                                triangle={{ position: "center", color: theme.palette.mode === "dark" ? colors.grey[300] : "#fff" }}

                            >
                                <StreamDisplayData />
                            </PopoverModal>

                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        flex: 2,
                        display: "flex",
                        gap: 1.5,
                        "@media screen and (max-width: 47.9375em)": {
                            flexDirection: "column",
                            minWidth: 130,
                        }
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            borderRadius: 4,
                            px: 2,
                            py: 1.5,
                            background: colors.pink[100],
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            "@media screen and (max-width: 47.9375em)": {
                                gap: 0,
                            }
                        }}
                    >

                        <Typography
                            sx={{
                                lineHeight: "17px",
                                fontFamily: "Roboto, sans-serif",
                                fontSize: 17,
                                fontWeight: "700",
                                color: colors.txt["primary"],
                                mb: "auto"
                            }}
                        >

                            {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_now_replenish)}
                        </Typography>
                        <Typography
                            sx={{
                                lineHeight: "14px",
                                fontFamily: "Roboto, sans-serif",
                                fontSize: 14,
                                fontWeight: "500",
                                color: colors.pink[400],
                            }}
                        >
                            <Trans
                                i18nKey="replenish_first"
                                components={{ br: <br /> }}
                            />
                        </Typography>
                        {/* <Text variant={"pink"} semibold>{t("replenish_first")}</Text> */}
                    </Box>
                    <Box
                        sx={{
                            overflow: "hidden",
                            flex: 1,
                            borderRadius: 4,
                            px: 2,
                            py: 1.5,
                            background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            "@media screen and (max-width: 47.9375em)": {
                                gap: 2,
                                pb: 3,
                            }
                        }}
                    >

                        <Typography
                            sx={{
                                lineHeight: "17px",
                                fontFamily: "Roboto, sans-serif",
                                fontSize: 17,
                                fontWeight: "700",
                                color: colors.txt["primary"],
                                mb: 'auto',
                            }}
                        >

                            {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_later_total)}
                        </Typography>
                        <Text light semibold>{t("to_process_later_today")}</Text>
                    </Box>
                </Box>

            </Box>

        </Box>
    );
};

// In the future: to-process tomorrow + after-tomorrow.
export const OrdersFutureToProcessCard = ({ totalData, isLoading, isFetching, sx }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            key={"today_to_process_future"}
            sx={{
                flex: 1,

                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                p: 1,
                pb: 1.5,
                px: 1.5,
                borderRadius: 5,
                display: "flex",
                flexDirection: "column",
                ...sx,
            }}
        >
            <Box
                sx={{
                    p: 1,
                    px: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: 'column'
                    }}
                >
                    <Text>{t("in_the_future")}</Text>
                    <Text light>{t("to_process")}</Text>
                </Box>

                <Typography
                    sx={{
                        lineHeight: "21px",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: 21,
                        fontWeight: "1000",
                        color: colors.txt["primary"]
                    }}
                >

                    {!isLoading && !isFetching && formatNumber(i18n, totalData?.later_all)}
                </Typography>

            </Box>
            {/* Amount split out */}
            <Box
                sx={{
                    flex: 1,
                    mt: 1,
                    display: "flex",
                    gap: 1.5,
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: "17px",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "700",
                            color: colors.txt["primary"],
                            mb: 'auto',
                        }}
                    >

                        {!isLoading && !isFetching && formatNumber(i18n, totalData?.later_tomorrow)}
                    </Typography>
                    <Text variant={theme.palette.mode === "dark" ? "blue" : "primary"} semibold>{t("to_process_tomorrow")}</Text>
                </Box>

                <Box
                    sx={{
                        overflow: "hidden",
                        flex: 1,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        minWidth: 120,
                        "@media screen and (max-width: 1024px)": {
                            minWidth: 120,
                        }
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: "17px",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "700",
                            color: colors.txt["primary"],
                            mb: 'auto',
                        }}
                    >

                        {!isLoading && !isFetching && formatNumber(i18n, totalData?.later_all - totalData?.later_tomorrow)}
                    </Typography>
                    <Text light semibold>{t("to_process_after_tomorrow")}</Text>
                </Box>

            </Box>

        </Box>
    );
};

// Action required: warehouse / office (or customer) / snoozed breakdown.
export const OrdersActionRequiredCard = ({ totalData, isLoading, isFetching, sx }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    return (
        <Box
            key={"action_required"}
            sx={{
                flex: 1,

                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                p: 1,
                pb: 1.5,
                px: 1.5,
                borderRadius: 5,
                display: "flex",
                flexDirection: "column",
                // flexShrink:0,
                ...sx,
            }}
        >
            <Box
                sx={{
                    p: 1,
                    px: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: 'column'
                    }}
                >
                    <Text>{t("important")}</Text>
                    <Text light>{t("action_required")}</Text>
                </Box>

                <Typography
                    sx={{
                        lineHeight: "21px",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: 21,
                        fontWeight: "1000",
                        color: colors.txt["primary"]
                    }}
                >

                    {!isLoading && !isFetching && formatNumber(i18n, totalData?.action_total)}
                </Typography>

            </Box>
            {/* Amount split out */}
            <Box
                sx={{
                    flex: 1,
                    mt: 1,
                    display: "flex",
                    gap: 1.5,
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: colors.orange[100],
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: "17px",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "700",
                            color: colors.txt["primary"],
                            mb: 'auto',
                        }}
                    >

                        {!isLoading && !isFetching && formatNumber(i18n, totalData?.action_paused)}
                    </Typography>
                    <Text variant={"orange"} semibold>{t("warehouse_action_required")}</Text>
                </Box>

                <Box
                    sx={{
                        overflow: "hidden",
                        flex: 1,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: colors.red[100],
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: "17px",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "700",
                            color: colors.txt["primary"],
                            mb: 'auto',
                        }}
                    >

                        {!isLoading && !isFetching && formatNumber(i18n, totalData?.action_maintenance)}
                    </Typography>
                    <Text variant="red" semibold>{isFulfilment ? t("customer_action_required") : t("office_action_required")}</Text>
                </Box>

                <Box
                    sx={{
                        overflow: "hidden",
                        flex: 1,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: colors.purple[100],
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: "17px",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "700",
                            color: colors.txt["primary"],
                            mb: 'auto',
                        }}
                    >

                        {!isLoading && !isFetching && formatNumber(i18n, totalData?.action_snooze)}
                    </Typography>
                    <Text variant="purple" semibold>{t("snoozed")}</Text>
                </Box>

            </Box>

        </Box>
    );
};

// B2B: open B2B (now + future) — only shown on the orders page when there is B2B volume.
export const OrdersB2BCard = ({ totalData, isLoading, isFetching, sx }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            key={"b2b"}
            sx={{
                flex: 0.5,

                background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                boxShadow: theme.palette.mode === "dark" ? null : `0px 2px 4px ${colors.grey[200]}`,
                p: 1,
                pb: 1.5,
                px: 1.5,
                borderRadius: 5,
                display: "flex",
                flexDirection: "column",
                ...sx,
            }}
        >
            <Box
                sx={{
                    p: 1,
                    px: 1.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 3,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: 'column'
                    }}
                >
                    <Text>{t("b2b")}</Text>
                    {/* <Text light>{t("action_required")}</Text> */}
                </Box>

                <Typography
                    sx={{
                        lineHeight: "21px",
                        fontFamily: "Roboto, sans-serif",
                        fontSize: 21,
                        fontWeight: "1000",
                        color: colors.txt["primary"]
                    }}
                >

                    {!isLoading && !isFetching && formatNumber(i18n, totalData?.today_now_b2b)}
                </Typography>

            </Box>

            {/* Amount split out */}
            <Box
                sx={{
                    flex: 1,
                    mt: 1,
                    display: "flex",
                    flexDirection: 'column',
                    gap: 1.5,
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: "17px",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "700",
                            color: colors.txt["primary"],
                            mb: 'auto',
                        }}
                    >

                        {!isLoading && !isFetching && formatNumber(i18n, (totalData?.today_now_b2b + totalData?.future_b2b))}
                    </Typography>
                    <Text variant={theme.palette.mode === "dark" ? "blue" : "primary"} semibold>{t("b2b_open")}</Text>
                </Box>

                <Box
                    sx={{
                        overflow: "hidden",
                        flex: 1,
                        borderRadius: 4,
                        px: 2,
                        py: 1.5,
                        background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        minWidth: 120,
                        "@media screen and (max-width: 1024px)": {
                            minWidth: 120,
                        }
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: "17px",
                            fontFamily: "Roboto, sans-serif",
                            fontSize: 17,
                            fontWeight: "700",
                            color: colors.txt["primary"],
                            mb: 'auto',
                        }}
                    >

                        {!isLoading && !isFetching && formatNumber(i18n, totalData?.future_b2b)}
                    </Typography>
                    <Text light semibold>{t("in_the_future")}</Text>
                </Box>

            </Box>

        </Box>
    );
};
